var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlipBackward = function SvgFlipBackward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#60646C",
    fillRule: "evenodd",
    d: "M5.139 2.862c.26.26.26.683 0 .943L3.61 5.334H11a3.667 3.667 0 0 1 0 7.333H8a.667.667 0 0 1 0-1.333h3a2.333 2.333 0 0 0 0-4.667H3.61l1.53 1.529a.667.667 0 1 1-.943.942L1.529 6.472a.667.667 0 0 1 0-.943l2.667-2.667c.26-.26.682-.26.943 0",
    clipRule: "evenodd"
  })));
};
export default SvgFlipBackward;